import { render, staticRenderFns } from "./ToothPopover.vue?vue&type=template&id=1b32b69a&scoped=true&"
import script from "./ToothPopover.vue?vue&type=script&lang=js&"
export * from "./ToothPopover.vue?vue&type=script&lang=js&"
import style0 from "./ToothPopover.vue?vue&type=style&index=0&id=1b32b69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32b69a",
  null
  
)

export default component.exports